/**
 * The app shell: sidebar navigation, header, website switcher, user menu,
 * impersonation banner and the not-found page.
 */
export default {
    nav: {
        sections: {
            content: 'Content',
            customers: 'Customers',
            commerce: 'Commerce',
            insights: 'Insights',
            system: 'System',
        },
        dashboard: 'Dashboard',
        pages: 'Pages',
        articles: 'Articles',
        landing: 'Landing pages',
        media: 'Media',
        portfolio: 'Portfolio',
        faq: 'FAQ',
        menus: 'Menus',
        redirects: 'Redirects',
        customers: 'Customers',
        customerGroups: 'Customer groups',
        vehicleStock: 'Vehicle stock',
        orders: 'Orders',
        products: 'Products',
        categories: 'Categories',
        productOptions: 'Product options',
        catalogDiscounts: 'Catalog discounts',
        vouchers: 'Vouchers',
        giftCards: 'Gift cards',
        shipping: 'Shipping',
        holidayClosure: 'Holiday closure',
        deliverySlots: 'Delivery moments',
        newsletter: 'Newsletter',
        reviewRequests: 'Review requests',
        abandonedCarts: 'Abandoned carts',
        formSubmissions: 'Form submissions',
        statistics: 'Statistics',
        websites: 'Websites',
        users: 'Users',
        vat: 'VAT',
        snelstart: 'SnelStart',
        taxTable: 'Tax table',
    },
    badges: {
        ordersToShip: '{n} paid order to ship | {n} paid orders to ship',
        unreadSubmissions: '{n} unread submission | {n} unread submissions',
    },
    /** `{gsid}` is the GSID link. */
    madeBy: 'Made by {gsid}',
    sidebar: {
        open: 'Open sidebar',
        close: 'Close sidebar',
        versionTitle: 'CMS {version}, built {date}',
    },
    impersonation: {
        viewingAs: 'Viewing as {email}',
        by: '(impersonated by {email})',
        exit: 'Exit impersonation',
        exiting: 'Exiting…',
    },
    websites: {
        search: 'Search websites…',
        noMatch: 'No websites match.',
        more: '{n} more, refine your search.',
        settings: 'Website settings',
        openLive: 'Open {host} in a new tab',
        viewLive: 'View live site',
    },
    userMenu: {
        profile: 'Profile',
        theme: 'Theme',
        logout: 'Log out',
    },
    theme: {
        system: 'System',
        light: 'Light',
        dark: 'Dark',
    },
    notFound: {
        message: "That page doesn't exist.",
        back: 'Back to dashboard',
    },
};
